import React, {useState} from 'react';
import {isEmailFormat} from "../../../../../Apis/functions";
import CustomCard from "../../../../../components/CustomCard";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {InputAdornment} from "@mui/material";
import {Mail} from "@mui/icons-material";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import {WHITE_LIST_MANUAL_MODEL} from "../Model/Models";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import DeleteModal from "../../../../Modals/DeleteModal";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const WhiteListManual = (
    {
        emptyFields,
        setEmptyFields,
        eventDetail,
        setEventDetail
    }
) => {
    const {t} = useTranslation();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedLevelId, setSelectedLevelId] = useState(null);

    /**
     * Updates a specific email entry in the whitelist list.
     *
     * Modifies only the field being edited while preserving the rest of the list.
     *
     * @param {Object} e - Input change event.
     * @param {number} index - Index of the whitelist item to update.
     */
    const handleChangeTemp = (e, index) => {
        const { name, value } = e.target;

        setEventDetail((prev) => {
            const whiteListManual = [...prev.whiteListManual];

            whiteListManual[index] = {
                ...whiteListManual[index],
                [name]: value,
            };

            return {
                ...prev,
                whiteListManual,
            };
        });
    };

    /**
     * Adds a new empty email entry to the whitelist list.
     *
     * Before adding, validates the current whitelist using eventDetail.isValidWhiteList().
     * If invalid, triggers empty field validation state.
     *
     * @returns {void}
     */
    const handleAdd = () => {
        if(!eventDetail?.isValidWhiteList()){
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        setEventDetail(prev => ({
            ...prev,
            whiteListManual: [...prev.whiteListManual, { ...WHITE_LIST_MANUAL_MODEL, id: `${Date.now()}-${Math.random()}` }]
        }));
    };

    /**
     * Removes an email entry from the whitelist list.
     *
     * Also displays a success toast after deletion.
     *
     * @param {Object} item - Whitelist item to remove.
     * @param {string|number} item.id - Unique identifier of the whitelist entry.
     */
    const handleDeleteItem = (item) => {
        setEventDetail((prev) => ({
            ...prev,
            whiteListManual: prev.whiteListManual.filter((currentItem) => currentItem.id !== item.id),
        }));
        toast.success(t('has_been_deleted_successfully'));
    };

    return (
        <>
            <div className={"col-12 mb-4"}>
                <CustomCard classCard="card-border-8px" >
                    { eventDetail?.whiteListManual?.map((e, index) => {
                        return <div className={"col-12 p-0 mb-3"}>
                            <div className={"row border-full-shades-300 background-shades-50 border-radius-8px input-padding-top"}>
                                <div className={"col-12"}>

                                    <div className={"d-flex"}>
                                        <div className={"w-100"}>
                                            <CustomTextField
                                                id={'txt_wlm_email'}
                                                length={128}
                                                name={'email'}
                                                value={e.email}
                                                trans={'email'}
                                                type={'text'}
                                                onChange={(event) => handleChangeTemp(event, index)}
                                                emptyFields={!e?.email && emptyFields}
                                                required={false}
                                                disabled={false}
                                                isValid={(!e?.email || isEmailFormat(e.email))}
                                                isValidText={'email_format_invalid'}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position='end'>
                                                            <Mail />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>

                                        { eventDetail?.whiteListManual?.length > 1 &&
                                            <div className={"pl-3"}>
                                                <ButtonIcon
                                                    id={'btn_wlm_delete'}
                                                    Icon={TrashOutlineIcon}
                                                    onClick={() => {
                                                        setSelectedLevelId(e);
                                                        setShowDeleteModal(true);
                                                    }}
                                                    className='btn-outlined-error-600 h-40px w-40px'
                                                    iconProps={'btn-icon-svg-24px'}
                                                />
                                            </div>
                                        }
                                    </div>


                                </div>
                            </div>
                        </div>
                    })
                    }

                    <div className='col-12 px-0'>
                        <ButtonAction
                            id='btn_wlm_add_email'
                            name='add_email'
                            Icon={AddIcon}
                            splitName={false}
                            className='btn-outlined-secondary-600-00'
                            disabled={false}
                            onClick={() => {
                                handleAdd();
                            }}
                        />
                    </div>
                </CustomCard>
            </div>

            <DeleteModal
                show={showDeleteModal}
                onHide={() => {
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                data={[selectedLevelId]}
                onClickFn={() => {
                    if (selectedLevelId !== null) {
                        handleDeleteItem(selectedLevelId);
                    }
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                title_modal={t('delete_email')}
                element_modal={t('email')}
            />
        </>
    )
}


export default WhiteListManual
